import type { ComponentProps, JSX } from 'react'

import {
  Popover,
  PopoverAnchor,
  PopoverContent as UiPopoverContent,
  PopoverTrigger
} from '../components/ui/popover.tsx'
import { cn } from '../lib/cn.ts'

/**
 * Square panel with the rule frame and no elevation.
 * The wrapper replaces the primitive corner and shadow styles.
 */
const CONTENT_CLASS =
  'rounded-none border-(length:--rule-width) border-rule bg-popover shadow-none'

export type PopoverContentProps = ComponentProps<typeof UiPopoverContent> & {
  'data-testid': string
}

/**
 * PopoverContent — the console's popover panel.
 *
 * Feature code imports this, not `components/ui/popover`. The trigger and
 * anchor are the primitive, re-exported below.
 *
 * @param props - Popover content props. `data-testid` is required.
 * @param props.className - Caller classes, which win over the house frame.
 * @returns The rendered panel.
 */
export function PopoverContent({
  className,
  'data-testid': testId,
  ...props
}: PopoverContentProps): JSX.Element {
  return (
    <UiPopoverContent
      data-testid={testId}
      className={cn(CONTENT_CLASS, className)}
      {...props}
    />
  )
}

export { Popover, PopoverAnchor, PopoverTrigger }
